import type { DevFlagsType } from "@/wab/shared/devflags";

export const DEFAULT_DEVFLAG_OVERRIDES: Partial<DevFlagsType> = {};
